import type * as React from 'react';

import type { AssignmentRubric, QuestionRubric } from 'bundles/grading/api/types';
import InlineFeedbackButton from 'bundles/grading/components/staff-graded-assignments/form-parts/InlineFeedbackButton';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import RubricShell from 'bundles/grading/components/staff-graded-assignments/form-parts/RubricShell';
import { isRubricBoxView } from 'bundles/grading/utils/submissionUtils';

export type RubricProps = {
  rubric: AssignmentRubric | QuestionRubric;
  isReadOnly?: boolean;
};

export const getRubricComponent = (rubric: AssignmentRubric | QuestionRubric): React.FC<RubricProps> => {
  if (isRubricBoxView(rubric)) {
    return InlineFeedbackButton;
  }

  return RubricShell;
};
